<template>
  <div class="create">
    <div class="model">
        <div class="body">
            <p class="title"></p>
            <p class="content"></p>
            <p class="btns" style="display:none"><span class="cancel">取消</span><span class="confirm">确定</span></p>
            <p class="foot" style="display:block"></p>
        </div>
    </div>
    <div class="loading" id="loading" v-show="loading"><div class="circle"></div></div>
    <img src="../images/index/topbanner.png" width="100%">
    <div class="block">
        <div class="info">填写参保人信息</div>
        <div class="logo"></div>
        <p class="label bb clearfix"><label for="user_name">姓名：</label><input type="text" id="user_name" v-model="formData.name" @focus="eidtName" maxlength="15" placeholder="请输入真实姓名" value=""></p>
        <p class="label bb clearfix"><label for="user_card">身份证号：</label><input type="text" id="user_card" v-model="formData.card" @focus="eidtCard" placeholder="请输入身份证号" maxlength="18"></p>
<!--
        <div class="label bb clearfix"><label for="demo_treelist_dummy">所在地区：</label>
            <div class="arrow"></div>
            <input type="hidden" name="province_id" id="province_id">
            <input type="hidden" name="city_id" id="city_id">
            <input type="hidden" name="provinceIndex" id="provinceIndex" value="-1">
            <input type="hidden" name="cityIndex" id="cityIndex" value="-1">
            <ul id="demo_treelist" style="display:none">
                <li data-id="110000">北京市
                    <ul>
                        <li data-id="110100" data-parent="110000">北京市</li>
                    </ul>
                </li>    
                <li data-id="120000">天津市
                    <ul>
                        <li data-id="120100" data-parent="120000">天津市</li>
                    </ul>
                </li>    
                <li data-id="130000">河北省
                    <ul>
                        <li data-id="130100" data-parent="130000">石家庄市</li>
                        <li data-id="130200" data-parent="130000">唐山市</li>
                        <li data-id="130300" data-parent="130000">秦皇岛市</li>
                        <li data-id="130400" data-parent="130000">邯郸市</li>
                        <li data-id="130500" data-parent="130000">邢台市</li>
                        <li data-id="130600" data-parent="130000">保定市</li>
                        <li data-id="130700" data-parent="130000">张家口市</li>
                        <li data-id="130800" data-parent="130000">承德市</li>
                        <li data-id="130900" data-parent="130000">沧州市</li>
                        <li data-id="131000" data-parent="130000">廊坊市</li>
                        <li data-id="131100" data-parent="130000">衡水市</li>
                    </ul>
                </li>    
                <li data-id="140000">山西省
                    <ul>
                        <li data-id="140100" data-parent="140000">太原市</li>
                        <li data-id="140200" data-parent="140000">大同市</li>
                        <li data-id="140300" data-parent="140000">阳泉市</li>
                        <li data-id="140400" data-parent="140000">长治市</li>
                        <li data-id="140500" data-parent="140000">晋城市</li>
                        <li data-id="140600" data-parent="140000">朔州市</li>
                        <li data-id="140700" data-parent="140000">晋中市</li>
                        <li data-id="140800" data-parent="140000">运城市</li>
                        <li data-id="140900" data-parent="140000">忻州市</li>
                        <li data-id="141000" data-parent="140000">临汾市</li>
                        <li data-id="141100" data-parent="140000">吕梁市</li>
                    </ul>
                </li>    
                <li data-id="150000">内蒙古自治区
                    <ul>
                        <li data-id="150100" data-parent="150000">呼和浩特市</li>
                        <li data-id="150200" data-parent="150000">包头市</li>
                        <li data-id="150300" data-parent="150000">乌海市</li>
                        <li data-id="150400" data-parent="150000">赤峰市</li>
                        <li data-id="150500" data-parent="150000">通辽市</li>
                        <li data-id="150600" data-parent="150000">鄂尔多斯市</li>
                        <li data-id="150700" data-parent="150000">呼伦贝尔市</li>
                        <li data-id="150800" data-parent="150000">巴彦淖尔市</li>
                        <li data-id="150900" data-parent="150000">乌兰察布市</li>
                        <li data-id="152200" data-parent="150000">兴安盟</li>
                        <li data-id="152500" data-parent="150000">锡林郭勒盟</li>
                        <li data-id="152900" data-parent="150000">阿拉善盟</li>
                    </ul>
                </li> 
                <li data-id="210000">辽宁省
                    <ul>
                        <li data-id="210100" data-parent="210000">沈阳市</li>
                        <li data-id="210200" data-parent="210000">大连市</li>
                        <li data-id="210300" data-parent="210000">鞍山市</li>
                        <li data-id="210400" data-parent="210000">抚顺市</li>
                        <li data-id="210500" data-parent="210000">本溪市</li>
                        <li data-id="210600" data-parent="210000">丹东市</li>
                        <li data-id="210700" data-parent="210000">锦州市</li>
                        <li data-id="210800" data-parent="210000">营口市</li>
                        <li data-id="210900" data-parent="210000">阜新市</li>
                        <li data-id="211000" data-parent="210000">辽阳市</li>
                        <li data-id="211100" data-parent="210000">盘锦市</li>
                        <li data-id="211200" data-parent="210000">铁岭市</li>
                        <li data-id="211300" data-parent="210000">朝阳市</li>
                        <li data-id="211400" data-parent="210000">葫芦岛市</li>
                    </ul>
                </li>    
                <li data-id="220000">吉林省
                    <ul>
                        <li data-id="220100" data-parent="220000">长春市</li>
                        <li data-id="220200" data-parent="220000">吉林市</li>
                        <li data-id="220300" data-parent="220000">四平市</li>
                        <li data-id="220400" data-parent="220000">辽源市</li>
                        <li data-id="220500" data-parent="220000">通化市</li>
                        <li data-id="220600" data-parent="220000">白山市</li>
                        <li data-id="220700" data-parent="220000">松原市</li>
                        <li data-id="220800" data-parent="220000">白城市</li>
                        <li data-id="222400" data-parent="220000">延边朝鲜族自治州</li>
                    </ul>
                </li>    
                <li data-id="230000">黑龙江省
                    <ul>
                        <li data-id="230100" data-parent="230000">哈尔滨市</li>
                        <li data-id="230200" data-parent="230000">齐齐哈尔市</li>
                        <li data-id="230300" data-parent="230000">鸡西市</li>
                        <li data-id="230400" data-parent="230000">鹤岗市</li>
                        <li data-id="230500" data-parent="230000">双鸭山市</li>
                        <li data-id="230600" data-parent="230000">大庆市</li>
                        <li data-id="230700" data-parent="230000">伊春市</li>
                        <li data-id="230800" data-parent="230000">佳木斯市</li>
                        <li data-id="230900" data-parent="230000">七台河市</li>
                        <li data-id="231000" data-parent="230000">牡丹江市</li>
                        <li data-id="231100" data-parent="230000">黑河市</li>
                        <li data-id="231200" data-parent="230000">绥化市</li>
                        <li data-id="232700" data-parent="230000">大兴安岭地区</li>
                    </ul>
                </li>   
                <li data-id="310000">上海市
                    <ul>
                        <li data-id="310100" data-parent="310000">上海市</li>
                    </ul>
                </li>    
                <li data-id="320000">江苏省
                    <ul>
                        <li data-id="320100" data-parent="320000">南京市</li>
                        <li data-id="320200" data-parent="320000">无锡市</li>
                        <li data-id="320300" data-parent="320000">徐州市</li>
                        <li data-id="320400" data-parent="320000">常州市</li>
                        <li data-id="320500" data-parent="320000">苏州市</li>
                        <li data-id="320600" data-parent="320000">南通市</li>
                        <li data-id="320700" data-parent="320000">连云港市</li>
                        <li data-id="320800" data-parent="320000">淮安市</li>
                        <li data-id="320900" data-parent="320000">盐城市</li>
                        <li data-id="321000" data-parent="320000">扬州市</li>
                        <li data-id="321100" data-parent="320000">镇江市</li>
                        <li data-id="321200" data-parent="320000">泰州市</li>
                        <li data-id="321300" data-parent="320000">宿迁市</li>
                    </ul>
                </li>    
                <li data-id="330000">浙江省
                    <ul>
                        <li data-id="330100" data-parent="330000">杭州市</li>
                        <li data-id="330200" data-parent="330000">宁波市</li>
                        <li data-id="330300" data-parent="330000">温州市</li>
                        <li data-id="330400" data-parent="330000">嘉兴市</li>
                        <li data-id="330500" data-parent="330000">湖州市</li>
                        <li data-id="330600" data-parent="330000">绍兴市</li>
                        <li data-id="330700" data-parent="330000">金华市</li>
                        <li data-id="330800" data-parent="330000">衢州市</li>
                        <li data-id="330900" data-parent="330000">舟山市</li>
                        <li data-id="331000" data-parent="330000">台州市</li>
                        <li data-id="331100" data-parent="330000">丽水市</li>
                    </ul>
                </li>    
                <li data-id="340000">安徽省
                    <ul>
                        <li data-id="340100" data-parent="340000">合肥市</li>
                        <li data-id="340200" data-parent="340000">芜湖市</li>
                        <li data-id="340300" data-parent="340000">蚌埠市</li>
                        <li data-id="340400" data-parent="340000">淮南市</li>
                        <li data-id="340500" data-parent="340000">马鞍山市</li>
                        <li data-id="340600" data-parent="340000">淮北市</li>
                        <li data-id="340700" data-parent="340000">铜陵市</li>
                        <li data-id="340800" data-parent="340000">安庆市</li>
                        <li data-id="341000" data-parent="340000">黄山市</li>
                        <li data-id="341100" data-parent="340000">滁州市</li>
                        <li data-id="341200" data-parent="340000">阜阳市</li>
                        <li data-id="341300" data-parent="340000">宿州市</li>
                        <li data-id="341400" data-parent="340000">巢湖市</li>
                        <li data-id="341500" data-parent="340000">六安市</li>
                        <li data-id="341600" data-parent="340000">亳州市</li>
                        <li data-id="341700" data-parent="340000">池州市</li>
                        <li data-id="341800" data-parent="340000">宣城市</li>
                    </ul>
                </li>    
                <li data-id="350000">福建省
                    <ul>
                        <li data-id="350100" data-parent="350000">福州市</li>
                        <li data-id="350200" data-parent="350000">厦门市</li>
                        <li data-id="350300" data-parent="350000">莆田市</li>
                        <li data-id="350400" data-parent="350000">三明市</li>
                        <li data-id="350500" data-parent="350000">泉州市</li>
                        <li data-id="350600" data-parent="350000">漳州市</li>
                        <li data-id="350700" data-parent="350000">南平市</li>
                        <li data-id="350800" data-parent="350000">龙岩市</li>
                        <li data-id="350900" data-parent="350000">宁德市</li>
                    </ul>
                </li>    
                <li data-id="360000">江西省
                    <ul>
                        <li data-id="360100" data-parent="360000">南昌市</li>
                        <li data-id="360200" data-parent="360000">景德镇市</li>
                        <li data-id="360300" data-parent="360000">萍乡市</li>
                        <li data-id="360400" data-parent="360000">九江市</li>
                        <li data-id="360500" data-parent="360000">新余市</li>
                        <li data-id="360600" data-parent="360000">鹰潭市</li>
                        <li data-id="360700" data-parent="360000">赣州市</li>
                        <li data-id="360800" data-parent="360000">吉安市</li>
                        <li data-id="360900" data-parent="360000">宜春市</li>
                        <li data-id="361000" data-parent="360000">抚州市</li>
                        <li data-id="361100" data-parent="360000">上饶市</li>
                    </ul>
                </li>    
                <li data-id="370000">山东省
                    <ul>
                        <li data-id="370100" data-parent="370000">济南市</li>
                        <li data-id="370200" data-parent="370000">青岛市</li>
                        <li data-id="370300" data-parent="370000">淄博市</li>
                        <li data-id="370400" data-parent="370000">枣庄市</li>
                        <li data-id="370500" data-parent="370000">东营市</li>
                        <li data-id="370600" data-parent="370000">烟台市</li>
                        <li data-id="370700" data-parent="370000">潍坊市</li>
                        <li data-id="370800" data-parent="370000">济宁市</li>
                        <li data-id="370900" data-parent="370000">泰安市</li>
                        <li data-id="371000" data-parent="370000">威海市</li>
                        <li data-id="371100" data-parent="370000">日照市</li>
                        <li data-id="371200" data-parent="370000">莱芜市</li>
                        <li data-id="371300" data-parent="370000">临沂市</li>
                        <li data-id="371400" data-parent="370000">德州市</li>
                        <li data-id="371500" data-parent="370000">聊城市</li>
                        <li data-id="371600" data-parent="370000">滨州市</li>
                        <li data-id="371700" data-parent="370000">荷泽市</li>
                    </ul>
                </li>    
                <li data-id="410000">河南省
                    <ul>
                        <li data-id="410100" data-parent="410000">郑州市</li>
                        <li data-id="410200" data-parent="410000">开封市</li>
                        <li data-id="410300" data-parent="410000">洛阳市</li>
                        <li data-id="410400" data-parent="410000">平顶山市</li>
                        <li data-id="410500" data-parent="410000">安阳市</li>
                        <li data-id="410600" data-parent="410000">鹤壁市</li>
                        <li data-id="410700" data-parent="410000">新乡市</li>
                        <li data-id="410800" data-parent="410000">焦作市</li>
                        <li data-id="410900" data-parent="410000">濮阳市</li>
                        <li data-id="411000" data-parent="410000">许昌市</li>
                        <li data-id="411100" data-parent="410000">漯河市</li>
                        <li data-id="411200" data-parent="410000">三门峡市</li>
                        <li data-id="411300" data-parent="410000">南阳市</li>
                        <li data-id="411400" data-parent="410000">商丘市</li>
                        <li data-id="411500" data-parent="410000">信阳市</li>
                        <li data-id="411600" data-parent="410000">周口市</li>
                        <li data-id="411700" data-parent="410000">驻马店市</li>
                    </ul>
                </li>    
                <li data-id="420000">湖北省
                    <ul>
                        <li data-id="420100" data-parent="420000">武汉市</li>
                        <li data-id="420200" data-parent="420000">黄石市</li>
                        <li data-id="420300" data-parent="420000">十堰市</li>
                        <li data-id="420500" data-parent="420000">宜昌市</li>
                        <li data-id="420600" data-parent="420000">襄樊市</li>
                        <li data-id="420700" data-parent="420000">鄂州市</li>
                        <li data-id="420800" data-parent="420000">荆门市</li>
                        <li data-id="420900" data-parent="420000">孝感市</li>
                        <li data-id="421000" data-parent="420000">荆州市</li>
                        <li data-id="421100" data-parent="420000">黄冈市</li>
                        <li data-id="421200" data-parent="420000">咸宁市</li>
                        <li data-id="421300" data-parent="420000">随州市</li>
                        <li data-id="422800" data-parent="420000">恩施土家族苗族自治州</li>
                        <li data-id="429000" data-parent="420000">省直辖行政单位</li>
                    </ul>
                </li>    
                <li data-id="430000">湖南省
                    <ul>
                        <li data-id="430100" data-parent="430000">长沙市</li>
                        <li data-id="430200" data-parent="430000">株洲市</li>
                        <li data-id="430300" data-parent="430000">湘潭市</li>
                        <li data-id="430400" data-parent="430000">衡阳市</li>
                        <li data-id="430500" data-parent="430000">邵阳市</li>
                        <li data-id="430600" data-parent="430000">岳阳市</li>
                        <li data-id="430700" data-parent="430000">常德市</li>
                        <li data-id="430800" data-parent="430000">张家界市</li>
                        <li data-id="430900" data-parent="430000">益阳市</li>
                        <li data-id="431000" data-parent="430000">郴州市</li>
                        <li data-id="431100" data-parent="430000">永州市</li>
                        <li data-id="431200" data-parent="430000">怀化市</li>
                        <li data-id="431300" data-parent="430000">娄底市</li>
                        <li data-id="433100" data-parent="430000">湘西土家族苗族自治州</li>
                    </ul>
                </li>    
                <li data-id="440000">广东省
                    <ul>
                        <li data-id="440100" data-parent="440000">广州市</li>
                        <li data-id="440200" data-parent="440000">韶关市</li>
                        <li data-id="440300" data-parent="440000">深圳市</li>
                        <li data-id="440400" data-parent="440000">珠海市</li>
                        <li data-id="440500" data-parent="440000">汕头市</li>
                        <li data-id="440600" data-parent="440000">佛山市</li>
                        <li data-id="440700" data-parent="440000">江门市</li>
                        <li data-id="440800" data-parent="440000">湛江市</li>
                        <li data-id="440900" data-parent="440000">茂名市</li>
                        <li data-id="441200" data-parent="440000">肇庆市</li>
                        <li data-id="441300" data-parent="440000">惠州市</li>
                        <li data-id="441400" data-parent="440000">梅州市</li>
                        <li data-id="441500" data-parent="440000">汕尾市</li>
                        <li data-id="441600" data-parent="440000">河源市</li>
                        <li data-id="441700" data-parent="440000">阳江市</li>
                        <li data-id="441800" data-parent="440000">清远市</li>
                        <li data-id="441900" data-parent="440000">东莞市</li>
                        <li data-id="442000" data-parent="440000">中山市</li>
                        <li data-id="445100" data-parent="440000">潮州市</li>
                        <li data-id="445200" data-parent="440000">揭阳市</li>
                        <li data-id="445300" data-parent="440000">云浮市</li>
                    </ul>
                </li>    
                <li data-id="450000">广西壮族自治区
                    <ul>
                        <li data-id="450100" data-parent="450000">南宁市</li>
                        <li data-id="450200" data-parent="450000">柳州市</li>
                        <li data-id="450300" data-parent="450000">桂林市</li>
                        <li data-id="450400" data-parent="450000">梧州市</li>
                        <li data-id="450500" data-parent="450000">北海市</li>
                        <li data-id="450600" data-parent="450000">防城港市</li>
                        <li data-id="450700" data-parent="450000">钦州市</li>
                        <li data-id="450800" data-parent="450000">贵港市</li>
                        <li data-id="450900" data-parent="450000">玉林市</li>
                        <li data-id="451000" data-parent="450000">百色市</li>
                        <li data-id="451100" data-parent="450000">贺州市</li>
                        <li data-id="451200" data-parent="450000">河池市</li>
                        <li data-id="451300" data-parent="450000">来宾市</li>
                        <li data-id="451400" data-parent="450000">崇左市</li>
                    </ul>
                </li>
                <li data-id="460000">海南省
                    <ul>
                        <li data-id="460100" data-parent="460000">海口市</li>
                        <li data-id="460200" data-parent="460000">三亚市</li>
                        <li data-id="469000" data-parent="460000">省直辖县级行政单位</li>
                    </ul>
                </li>    
                <li data-id="500000">重庆市
                    <ul>
                        <li data-id="500100" data-parent="500000">重庆市</li>    
                    </ul>
                </li>    
                <li data-id="510000">四川省
                    <ul>
                        <li data-id="510100" data-parent="510000">成都市</li>
                        <li data-id="510300" data-parent="510000">自贡市</li>
                        <li data-id="510400" data-parent="510000">攀枝花市</li>
                        <li data-id="510500" data-parent="510000">泸州市</li>
                        <li data-id="510600" data-parent="510000">德阳市</li>
                        <li data-id="510700" data-parent="510000">绵阳市</li>
                        <li data-id="510800" data-parent="510000">广元市</li>
                        <li data-id="510900" data-parent="510000">遂宁市</li>
                        <li data-id="511000" data-parent="510000">内江市</li>
                        <li data-id="511100" data-parent="510000">乐山市</li>
                        <li data-id="511300" data-parent="510000">南充市</li>
                        <li data-id="511400" data-parent="510000">眉山市</li>
                        <li data-id="511500" data-parent="510000">宜宾市</li>
                        <li data-id="511600" data-parent="510000">广安市</li>
                        <li data-id="511700" data-parent="510000">达州市</li>
                        <li data-id="511800" data-parent="510000">雅安市</li>
                        <li data-id="511900" data-parent="510000">巴中市</li>
                        <li data-id="512000" data-parent="510000">资阳市</li>
                        <li data-id="513200" data-parent="510000">阿坝藏族羌族自治州</li>
                        <li data-id="513300" data-parent="510000">甘孜藏族自治州</li>
                        <li data-id="513400" data-parent="510000">凉山彝族自治州</li>
                    </ul>
                </li>    
                <li data-id="520000">贵州省
                    <ul>
                        <li data-id="520100" data-parent="520000">贵阳市</li>
                        <li data-id="520200" data-parent="520000">六盘水市</li>
                        <li data-id="520300" data-parent="520000">遵义市</li>
                        <li data-id="520400" data-parent="520000">安顺市</li>
                        <li data-id="522200" data-parent="520000">铜仁地区</li>
                        <li data-id="522300" data-parent="520000">黔西南布依族苗族自治州</li>
                        <li data-id="522400" data-parent="520000">毕节地区</li>
                        <li data-id="522600" data-parent="520000">黔东南苗族侗族自治州</li>
                        <li data-id="522700" data-parent="520000">黔南布依族苗族自治州</li>
                    </ul>
                </li>    
                <li data-id="530000">云南省
                    <ul>
                        <li data-id="530100" data-parent="530000">昆明市</li>
                        <li data-id="530300" data-parent="530000">曲靖市</li>
                        <li data-id="530400" data-parent="530000">玉溪市</li>
                        <li data-id="530500" data-parent="530000">保山市</li>
                        <li data-id="530600" data-parent="530000">昭通市</li>
                        <li data-id="530700" data-parent="530000">丽江市</li>
                        <li data-id="530800" data-parent="530000">思茅市</li>
                        <li data-id="530900" data-parent="530000">临沧市</li>
                        <li data-id="532300" data-parent="530000">楚雄彝族自治州</li>
                        <li data-id="532500" data-parent="530000">红河哈尼族彝族自治州</li>
                        <li data-id="532600" data-parent="530000">文山壮族苗族自治州</li>
                        <li data-id="532800" data-parent="530000">西双版纳傣族自治州</li>
                        <li data-id="532900" data-parent="530000">大理白族自治州</li>
                        <li data-id="533100" data-parent="530000">德宏傣族景颇族自治州</li>
                        <li data-id="533300" data-parent="530000">怒江傈僳族自治州</li>
                        <li data-id="533400" data-parent="530000">迪庆藏族自治州</li>
                    </ul>
                </li>    
                <li data-id="540000">西藏自治区
                    <ul>
                        <li data-id="540100" data-parent="540000">拉萨市</li>
                        <li data-id="542100" data-parent="540000">昌都地区</li>
                        <li data-id="542200" data-parent="540000">山南地区</li>
                        <li data-id="542300" data-parent="540000">日喀则地区</li>
                        <li data-id="542400" data-parent="540000">那曲地区</li>
                        <li data-id="542500" data-parent="540000">阿里地区</li>
                        <li data-id="542600" data-parent="540000">林芝地区</li>
                    </ul>
                </li>  
                <li data-id="610000">陕西省
                    <ul>
                        <li data-id="610100" data-parent="610000">西安市</li>
                        <li data-id="610200" data-parent="610000">铜川市</li>
                        <li data-id="610300" data-parent="610000">宝鸡市</li>
                        <li data-id="610400" data-parent="610000">咸阳市</li>
                        <li data-id="610500" data-parent="610000">渭南市</li>
                        <li data-id="610600" data-parent="610000">延安市</li>
                        <li data-id="610700" data-parent="610000">汉中市</li>
                        <li data-id="610800" data-parent="610000">榆林市</li>
                        <li data-id="610900" data-parent="610000">安康市</li>
                        <li data-id="611000" data-parent="610000">商洛市</li>
                    </ul>
                </li>    
                <li data-id="620000">甘肃省
                    <ul>
                        <li data-id="620100" data-parent="620000">兰州市</li>
                        <li data-id="620200" data-parent="620000">嘉峪关市</li>
                        <li data-id="620300" data-parent="620000">金昌市</li>
                        <li data-id="620400" data-parent="620000">白银市</li>
                        <li data-id="620500" data-parent="620000">天水市</li>
                        <li data-id="620600" data-parent="620000">武威市</li>
                        <li data-id="620700" data-parent="620000">张掖市</li>
                        <li data-id="620800" data-parent="620000">平凉市</li>
                        <li data-id="620900" data-parent="620000">酒泉市</li>
                        <li data-id="621000" data-parent="620000">庆阳市</li>
                        <li data-id="621100" data-parent="620000">定西市</li>
                        <li data-id="621200" data-parent="620000">陇南市</li>
                        <li data-id="622900" data-parent="620000">临夏回族自治州</li>
                        <li data-id="623000" data-parent="620000">甘南藏族自治州</li>
                    </ul>
                </li>    
                <li data-id="630000">青海省
                    <ul>
                        <li data-id="630100" data-parent="630000">西宁市</li>
                        <li data-id="632100" data-parent="630000">海东地区</li>
                        <li data-id="632200" data-parent="630000">海北藏族自治州</li>
                        <li data-id="632300" data-parent="630000">黄南藏族自治州</li>
                        <li data-id="632500" data-parent="630000">海南藏族自治州</li>
                        <li data-id="632600" data-parent="630000">果洛藏族自治州</li>
                        <li data-id="632700" data-parent="630000">玉树藏族自治州</li>
                        <li data-id="632800" data-parent="630000">海西蒙古族藏族自治州</li>
                    </ul>
                </li>    
                <li data-id="640000">宁夏回族自治区
                    <ul>
                        <li data-id="640100" data-parent="640000">银川市</li>
                        <li data-id="640200" data-parent="640000">石嘴山市</li>
                        <li data-id="640300" data-parent="640000">吴忠市</li>
                        <li data-id="640400" data-parent="640000">固原市</li>
                        <li data-id="640500" data-parent="640000">中卫市</li>
                    </ul>
                </li>
                <li data-id="650000">新疆维吾尔自治区
                    <ul>
                        <li data-id="650100" data-parent="650000">乌鲁木齐市</li>
                        <li data-id="650200" data-parent="650000">克拉玛依市</li>
                        <li data-id="652100" data-parent="650000">吐鲁番地区</li>
                        <li data-id="652200" data-parent="650000">哈密地区</li>
                        <li data-id="652300" data-parent="650000">昌吉回族自治州</li>
                        <li data-id="652700" data-parent="650000">博尔塔拉蒙古自治州</li>
                        <li data-id="652800" data-parent="650000">巴音郭楞蒙古自治州</li>
                        <li data-id="652900" data-parent="650000">阿克苏地区</li>
                        <li data-id="653000" data-parent="650000">克孜勒苏柯尔克孜自治州</li>
                        <li data-id="653100" data-parent="650000">喀什地区</li>
                        <li data-id="653200" data-parent="650000">和田地区</li>
                        <li data-id="654000" data-parent="650000">伊犁哈萨克自治州</li>
                        <li data-id="654200" data-parent="650000">塔城地区</li>
                        <li data-id="654300" data-parent="650000">阿勒泰地区</li>
                        <li data-id="659000" data-parent="650000">省直辖行政单位</li>
                    </ul>
                </li>
            </ul>
        </div>
        <p class="label bb clearfix"><input type="text" style="left:0;text-indent: 0" id="user_addr" name="user_addr" v-model="formData.addr" placeholder="请输入详细地址"></p>
        <p class="label bb clearfix bn"><label for="user_email">E-mail：</label><input type="text" id="user_email" v-model="formData.email" placeholder="请输入邮箱"></p>
-->
        <div class="notice">信息保护声明</div>
        <div class="noticeInfo">以上信息只供WiFi安全险登记及理赔用途，并不会用于其他商业用途。</div>
        
    </div>
    <div class="footer">
        <p class="protocol"><span class="checkbox checked"></span>本人同意并接受
            <span  @click="clickProtocol(protocol)" v-if="protocol == 'protocol'">《WiFi万能钥匙理赔服务协议》</span>
            <span  @click="clickProtocol(protocol)" v-if="protocol == 'protocolIos'">《WiFi万能钥匙理赔服务协议》</span>
            <span  @click="clickProtocol(protocol)" v-if="protocol == 'protocolIvvi'">《免费WiFi理赔服务协议》</span>
            <span  @click="clickProtocol(protocol)" v-if="protocol == 'protocolA0009'">《免费WiFi理赔服务协议》</span>
        </p>
        <p class="errorMsg"></p>
        <p class="buttons">
            <a class="button btn" @click="create">参保安心上网</a>
        </p>
    </div>
<!--
    <div class="block" style="padding-top:0">
        <p class="label clearfix bn"><label for="user_mobile">手机号：</label><input type="text" id="user_mobile"  v-model="formData.user_mobile" placeholder="请输入经过实名认证的手机号码" maxlength="11"></p>
    </div>
-->
    <qa :type="3"></qa>
    <div class="logo-image"></div>
    <div class="copyright" style="padding-bottom:12px">南京尚网网络科技有限公司对以上信息保留最终解释权</div>

    <div class="alert-model" v-if="showAlertModel">
      <div class="body">
          <p class="title">温馨提示</p>
          <p class="content">{{modelContent}}</p>
          <p class="description"><img src="../assets/tip.png" />如手机号码有更换，请联系官方客服</p>
          <p class="description" style="margin-bottom: 20px">客服电话：<a href="tel:4000358000">4000358000</a><span class="copy-qq" @click="copyQq(4000358000)">复制</span></p>
          <p class="btns" style="display:none"><span class="cancel">取消</span><span class="confirm">确定</span></p>
          <p class="foot" style="display:block" @click="cancel">我知道了</p>
      </div>
    </div>
  </div>
</template>

<script>
import qa from '@/components/qa'
  
const AES = require('@/lib/Utils/AES').default
import Clipboard from 'clipboard';
import Toast from './toast'

export default {
  name: 'create',
  components: {
    qa
  },
  created() {
    try {
      this.formData = JSON.parse(sessionStorage.getItem('PERSONAL_INFO' || null)) || {}
    } catch (error) { }
  },
  mounted:function(){
      var _self = this;
      Utils.Bridge.call('getAppInfo',{
        success:function(o){
            _self.appinfo = o;
            _self.bindEvent();

            if(o.chanid == 'ivvi'){
               _self.protocol='protocolIvvi'
            }else if(o.appid == 'A0009'){
               _self.protocol='protocolA0009'
            }else if(o.appid == 'I0010'){
               _self.protocol='protocolIos'
            }else{
               _self.protocol='protocol'
            }
            
            var provinceIndex = $('#provinceIndex').val(),
                cityIndex = $('#cityIndex').val();
            if(provinceIndex>=0&&cityIndex>=0){
                _self.setSelectValue([provinceIndex,cityIndex]);
            }
        }
    });
    _self.$trace.enterTraceDone({page: 4})

    // Utils.Tracker.send({
    //     data: {
    //         f: 'wifiins',
    //         b: 'ins_profile'
    //     }
    // });
  },
  data () {
    return {
        protocol:'protocol',
        appinfo:'',
        showAlertModel: false,
        modelContent: '',
        loading:false,
        formData:{
            name:'',
            card:'',
//            addr:'',
//            email:'',
//            user_mobile:''
        }
    }
  },
    methods:{
        bindEvent:function(){
            var _self = this;
            
//            $('#demo_treelist').mobiscroll().treelist({
//                theme: 'android-holo-light',
//                mode: 'scroller',
//                display: 'bottom',
//                lang: 'zh',       
//                placeholder:'请点击选择',
//                buttons:['cancel','set'],
//                headerText: function (valueText) { return "选择城市"; },
//                onSelect : function(valueText,inst){
//                    var arr = inst.getArrayVal();
//                    $('#provinceIndex').val(arr[0]);
//                    $('#cityIndex').val(arr[1]);
//                },
//                formatResult: function (array) { //返回自定义格式结果  
//                    var province = $('#demo_treelist>li').eq(array[0]);
//                    var city = $('#demo_treelist>li').eq(array[0]).find('ul li').eq(array[1]);
//                    var dataId = city.attr('data-id');
//                    var parent = city.attr('data-parent');
//                    $('#province_id').val(parent);
//                    $('#city_id').val(dataId);
//                    var rtn = province.contents().eq(0).text().trim() +' '+ city.text().trim(' ');
//                    if(rtn.length>12){
//                        return rtn.substring(0,12)+'...';
//                    }else{
//                        return rtn;    
//                    }
//                }
//            });
            $('.main input').bind({
                focus:function(){
                    if($(this).parent('p').hasClass('error')){
                        $(this).parent('p').removeClass('error');
                        $(this).val('');
                    }
                }
            });
            $('.protocol .checkbox').bind('click',function(){
                $(this).toggleClass('checked');
            });
            _self.formData.user_mobile = _self.appinfo.ph || _self.appinfo.mobile;
        },
        create:function(){
            var _self = this;
            _self.$trace.trace('ins_join_btn', 'ind')
            console.log(`填写页面，点参保按钮`)
            if(!_self.hasEmpty()&&_self.checkName()&&_self.checkIDCard()){
                if($('.protocol .checkbox').hasClass('checked')){
                    $('.errorMsg').hide();
                    // Utils.Tracker.send({
                    //     data: {
                    //         f: 'wifiins',
                    //         b: 'ins_confirm'
                    //     }
                    // });
                    safe.confirm({
                        title:'温馨提示',
                        content:'众安保险提醒您:请确保您的信息真实有效，以保障您后期的索赔权益，否则将失去索赔权益',
                        callback:function(){
                            _self.saveUserInfo();
                        }
                    });
                }else{
                    safe.model({
                        title:'温馨提示',
                        content:'同意WiFi万能钥匙理赔服务协议才能参保',
                        foot:'我知道了'
                    });
                }
            }
            safe.bindModelEvent();
        },
        saveUserInfo:function(){
            var _self = this;
            // Utils.Tracker.send({
            //     data: {
            //         f: 'wifiins',
            //         b: 'ins_join'
            //     }
            // });

//             {
//                 "dhid": _self.appinfo.dhid,
//                 "uhid": _self.appinfo.uhid,
//                 "vcode": _self.appinfo.vcode,
// //                "wifi_mobile": _self.appinfo.ph || _self.appinfo.mobile,
//                 "user_name": AES.Encrypt(_self.formData.name, obj),
// //                "user_mobile": _self.formData.user_mobile,
//                 "user_card":  AES.Encrypt(_self.formData.card, obj), 
// //                "user_email": _self.formData.email,
// //                "user_addr": _self.formData.addr,
// //                "province_id": $('#province_id').val(),
// //                "city_id": $('#city_id').val()
//             }

            let data = {
              "dhid": _self.appinfo.dhid,
              "uhid": _self.appinfo.uhid,
              "vcode": _self.appinfo.vcode,
              "user_name": _self.formData.name,
              "user_card": _self.formData.card, 
            }
            let ed = AES.Encrypt( JSON.stringify(data), AES.obj())
            _self.loading = true;
            this.$http.post(_host + '/user/save',{
                ed: ed,
            },{
                emulateJSON: true
            }).then(function(response){
                _self.loading = false;
                var json = response.body;
                if(json.c=='0000'){
                    $('.model').hide();
                    _self.$router.push("/createSuccess");
                    Utils.Bridge.call('notifyAction', {
                        event: 'insurance'
                    });
                }else if(json.c=='2012'){ // 身份证被占用
                    $('.model').hide();
                    this.showAlertModel = true
                    this.modelContent = json.m
                }else{
                    $('.model').hide();
                    safe.model({
                        title:'温馨提示',
                        content:json.m,
                        foot:'我知道了'
                    });
                    // Utils.Tracker.send({
                    //     data: {
                    //         f: 'wifiins',
                    //         b: 'ins_join_fail'
                    //     }
                    // });
                    safe.bindModelEvent();
                }
            })
        },
        hasEmpty : function(){
            for(var key in this.formData){
                if(this.formData[key] === ''){
                    safe.model({
                        title:'温馨提示',
                        content:'请填写完整再提交保单',
                        foot:'我知道了'
                    });
                    return true;
                }
            }
            return false;
        },
        copyQq(val) {
          var clipboard = new Clipboard('.copy-qq', {
            text: function() {
                return val;
            }
          });
          clipboard.on('success',(e)=> {
              Toast('复制成功')
              this.cancel()
              console.info('触发的方式（复制还是剪切）', e.text);
          })
        },
        checkIDCard : function(){
            var idcard = this.formData.card;
            var _id = this.parseID(idcard);
            if (isNaN(_id.substr(0, 17))){
                // Utils.Tracker.send({
                //     data: {
                //         f: 'wifiins',
                //         b: 'ins_idcard_fail'
                //     }
                // });
                safe.model({
                    title:'温馨提示',
                    content:'身份证号码格式有误',
                    foot:'我知道了'
                });
                return false;
            }
            return true;
        },
        checkName : function(){
            var reg = /^([\uFF0E\uFF07\uFF0F\.\•\·\uFF0D\u4E00-\u9FA5\uF900-\uFA2D\uB0A1-\uF7FE]{2,15})$/,
                username = this.formData.name;
            if(!reg.test(username)){
                safe.model({
                    title:'温馨提示',
                    content:'姓名格式不正确',
                    foot:'我知道了'
                });
            }else{
                return true;
            }
        },
        eidtName: function(){
          this.$trace.trace('ins_join_name', 'ind')
        },
        eidtCard: function(){
            this.$trace.trace('ins_join_id', 'ind')
            console.log(`身份证号输入框`)
        },
        clickProtocol(val){
            this.$trace.trace('ins_join_agreement', val)
            sessionStorage.setItem('PERSONAL_INFO', JSON.stringify(this.formData))
            console.log(`Protocol`)
            this.$router.push(val)
        },
        cancel() {
          this.showAlertModel = false
        },
//        checkMail : function(){
//            var reg =  /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
//                email = this.formData.email;
//            if(!reg.test(email)){
//                safe.model({
//                    title:'温馨提示',
//                    content:'邮箱格式不正确',
//                    foot:'我知道了'
//                });
//            }else{
//                return true;
//            }
//        },
//        checkMobile : function(){
//            var reg =  /^(1[3-9][0-9])\d{8}$/,
//                mobile = this.formData.user_mobile;
//            if(!reg.test(mobile)){
//                safe.model({
//                    title:'温馨提示',
//                    content:'手机号格式不正确',
//                    foot:'我知道了'
//                });
//            }
//            return(reg.test(mobile));
//        },
//        checkAddr : function(){
//            var l = this.formData.addr.length;
//            if(l < 4){
//                safe.model({
//                    title:'温馨提示',
//                    content:'地址长度过短，地址字数需要超过4个字符',
//                    foot:'我知道了'
//                });
//                return false;
//            }
//            if(l > 60){
//                safe.model({
//                    title:'温馨提示',
//                    content:'地址长度过长，地址字数不能超过60个字符',
//                    foot:'我知道了'
//                });
//                return false;
//            }
//            return true;
//        },
        parseID : function(pId) {
            var arrVerifyCode = [1, 0, "x", 9, 8, 7, 6, 5, 4, 3, 2];
            var wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            if (pId.length != 15 && pId.length != 18) {
                return ("身份证号码只能是15位或18位!");
            }
            var ai = (pId.length == 18) ? pId.substr(0, 17) : pId.substr(0, 6) + "19" + pId.substr(6);
            if (!/^\d+$/.test(ai)) {
                return ("身份证除最后一位外，必须为数字！");
            }
            var yyyy = ai.substr(6, 4),
                mm = ai.substr(10, 2) - 1,
                dd = ai.substr(12, 2);
            var d = new Date(yyyy, mm, dd),
                year = d.getFullYear(),
                mon = d.getMonth(),
                day = d.getDate(),
                now = new Date();
            if (year != yyyy || mon != mm || day != dd || d > now || now.getFullYear() - year > 140) {
                return ("身份证出生年月日输入错误！");
            }
            for (var i = 0, ret = 0; i < 17; i++) {
                ret += ai.charAt(i) * wi[i];
            }
            ai += arrVerifyCode[ret %= 11];
            return ((pId.length == 18 && pId.toLowerCase() != ai) ? "身份证输入错误，正确的为\n" + ai + "！" : ai);
        },
//        setSelectValue : function(values){
//            $('#demo_treelist').mobiscroll('setValue',values,true,0,false);
//        },
    }
}
</script>

<style scoped>
@import '../mobiscroll/css/mobiscroll.animation.css';
@import '../mobiscroll/css/mobiscroll.frame.css';
@import '../mobiscroll/css/mobiscroll.frame.android-holo.css';
@import '../mobiscroll/css/mobiscroll.scroller.css';
@import '../mobiscroll/css/mobiscroll.scroller.android-holo.css';
@import '../mobiscroll/css/mobiscroll.android-holo-light.css';
.f12{font-size: 12px;}
.f14{font-size: 14px;}
.c3{color: #333;}
.fb{font-weight: bold;}
.t_c{text-align: center;}
.ti{text-indent:18px}
.block{color: #666666;padding: 0 6%;background-color: #ffffff;padding-top: 15px;}
.block .label{position: relative;padding-right: 0;padding-left: 0;min-height: 46px;}
.block label{width: 25%;display: inline-block;line-height: 45px;color: #666666;}
.block input{
    position: absolute;
    left: 25%;
    width: 75%;
    overflow: hidden;
    height: 45px;
    line-height: 14px;
    font-size: 14px;
    color: #666666;
    border:none;
    background-color: transparent;
    text-indent: 10px;
    word-break: keep-all;
    white-space: nowrap;
}
.block .arrow{
    position: absolute;
    right: 0;
    top: 16px;
    width: 11px;
    height: 13px;
    background: url(../images/arrow.png) top center no-repeat;
    -webkit-background-size: 100%;
    background-size: 100%;
}
input{background:none; }
input[placeholder], [placeholder], *[placeholder] { 
    word-break: keep-all;
    white-space: nowrap
} 
.block .bn{border:none;}
.log_title span{
    display: block;
    width: 35%;
    height: 44px;
    line-height: 44px;
    padding-left: 58px;
    margin: 0 auto;
    font-size: 24px;
    color: #333333;
    background: url(../images/gou.png) no-repeat 0 0;
    background-size: 44px 44px;
}

.alert-model {
    position: fixed;
    top: 0;
    z-index: 99999;
    background-color: rgba(0,0,0,.4);
    width: 100%;
    height: 100%;
}
.alert-model .body {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -45%;
    margin-top: -90px;
    border-radius: 3px;
    width: 90%;
    background-color: #ffffff;
}
.alert-model .title{font-weight: normal;padding-left: 24px;margin-top: 16px; font-size: 18px;}

.alert-model .content{color: #484a50;font-size: 15px;line-height: 20px;padding: 0 24px 12px 24px;margin-top: 7px;}

.alert-model .description{font-size: 13px;line-height: 20px;padding: 0 24px 0px 24px;margin-bottom: 0px; color: #999999;}
.alert-model .foot{text-align: center;line-height: 54px;}
.alert-model .foot{color: #0285f0;font-size: 17px;text-align: center;line-height: 54px;border: none;}
.alert-model .foot,.alert-model .btns{
    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAABlBMVEUAAADb29tXdnSWAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjYGA4AAAAxADBPcXUKgAAAABJRU5ErkJggg==);
    background-repeat: repeat-x;
    background-position: 0 top;
    background-size: auto 1px,1px auto;
    padding:0;
}
.alert-model img{
  margin-top: 3px;
  width: 14px;
  margin-right: 4px;
}
.copy-qq{
  font-size: 13px;
  color: #0285F0;
  letter-spacing: 0;
  line-height: 13px;
  padding: 12px 10px;
}
.alert-model .cancel,.alert-model .confirm{text-align: center;display:inline-block;width: 50%;box-sizing: border-box!important; -webkit-box-sizing: border-box!important;line-height: 20px;font-size: 17px;}
.alert-model .cancel{}
.alert-model .confirm{border-left: 1px #f2f2f2 solid;color: #0285f0;}

.claimNumber{line-height: 20px;color: #EE5D4D;border-bottom: #cccccc 1px dotted;  padding-bottom: 10px;}
.claimNumber span{font-size: 20px;}

.title{font-size: 16px; color: #0285f0;  line-height: 20px}
.title2{font-size: 12px; color: #666666; font-weight: bold;  line-height: 20px;margin:16px 0; }
.title_bold{font-size: 12px; color: #333333; font-weight: bold;  line-height: 22px;}
.label{font-size: 14px;color:#333333;}
.label span{color:#EE5D4D;}


.error{color: #ee5d4d;font-size: 12px;}
.error input{color: #ee5d4d;font-size: 12px;}
.notes{margin-top: 17px;margin-bottom: 2px;}
.text{font-size: 12px;color: #666666;line-height: 24px; margin-bottom: 3px;}

.protocol{font-size: 13px;line-height: 48px;}
.protocol span{color: #0285f0;}
.protocol a{text-decoration: underline;}
.protocol .checkbox{
    display: inline-block;  
    margin-right: 8px;
    height: 16px;
    width: 16px;
    vertical-align: middle;
    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAJFBMVEUAAAAVy3MVy3MVy3MVy3MVy3MVy3MVy3MVy3MVy3MVy3MVy3M854VxAAAAC3RSTlMAGfXPxwZuGLe1b92m5XYAAABmSURBVDjLY2AIc9qNAVRSGRgYrXdjAZsFGIJ3YwWmDNnYJbYxeO9uZMAAEru3MGjvFsCUYNy9iWH3bgZMABQdlRiVGJWgiwT2zMkOzJzeu6djSlTu3oKzAMBZZOAuZBiisBVLSxkA08D0NA1nVgcAAAAASUVORK5CYII=);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100%;
}
.protocol .checked{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAVFBMVEUAAAAVy3MVy3MVy3MVy3MVy3MVy3MVy3MVy3MVy3P///9E1o9q3qbw/PYiznvL8+AYzHWr7MzB8dpf3KD3/foq0ICf6sZn3aTy/PeH5Lc00oYr0IAv2snRAAAACXRSTlMA9sgGz24bb9HQtZIcAAAA2UlEQVRIx93Wyw7CMAxEUbehLXGglKQPHv//n2Q3QiNRe1cx63u2iUUkdG0TDWvaLkhdf4rmnXqRgN4ignTRtU5aH2il8YFGonNHAa81PycHSFdVzQCWvi4BmHotAKZ+XgAsvW4RwNJfIoCnBxjTYugBykN1nfZ6gGXWuvu00wMUVQjuGSSF4J5AXYb41QOMNwjqCbBI6Bmw+OoZsKCeAASGngAJ6glAcM+ABfcMILhnwAI9AxJZdd5cD1kq7+O/rf8GvJ+i+9t1f+zO0+Ec3MdJXRis588QRD5melMoB91cFwAAAABJRU5ErkJggg==);
}

.errorMsg{color: #ee5d4d;font-size: 12px;line-height: 24px;display: none;}
.buttons{margin-bottom: 36px;}
a.button {
    display: block;
    height: 46px;
    width: 100%;
    text-decoration: none;
    font-size: 18px;
    line-height: 46px;
    text-align: center;
    -webkit-border-radius: 23px;
    -moz-border-radius: 23px;
    border-radius: 23px;
    color: #ffffff;
    background:-webkit-linear-gradient(left,#42A9FD,#0285F0)
}

.voucher{font-size: 14px;color: #0285f0; position: absolute; bottom: 24px;text-align: center;width: 100%;}
.mbsc-android-holo-light .dwb-a{background: #ebebeb;}
.mbsc-android-holo-light .dwwol {
    border-top: 1px solid #0285f0;
    border-bottom: 1px solid #0285f0;
}
.mbsc-android-holo-light .dwv {
    color: #0285f0;
    border-bottom: 1px solid #0285f0;
    line-height: 2.8em;
}
.mbsc-android-holo .dwb {
    height: 3.6em;
    line-height: 3.6em;
}
.logo-image{
    margin-top: 30px;
    width: 100%;
    padding-top: 2.9%;
    background: url(../images/index/logo-image.png) no-repeat center;
    background-size: contain;
}
.copyright{
    font-size: 12px;
    line-height: 26px;
    color: #E0E0E0;
    text-align: center;
    font-weight: 300;
}
    .block{
        position: relative;
    }
    .block .info{
        font-size: 18px;
        line-height: 26px;
        margin:3px 0 16px 0;
        color: #333;
    }
    .block .logo{
        position: absolute;
        width: 29.8667%;
        padding-top: 5.6%;
        right:18px;
        top:20px;
        background: url(../images/index/byzhongan.png) no-repeat center;
        background-size: contain;
    }
    .block .notice{
        color: #333;
        font-size: 14px;
        line-height: 26px;
        margin-top:18px;
    }
    .block .noticeIngo{
        color: #151515;
        font-size: 14px;
        line-height: 26px;
    }
    .footer{
        margin-top: -15px;
        background: #fff;
        margin-bottom: 12px;
        padding-bottom: 8px;
    }
</style>



// WEBPACK FOOTER //
// create.vue?3df8d404